export default {
  fullscreen: 'Fullscreen',
  exitFullscreen: 'Exit fullscreen'
}
